import script from "./listSubject.vue?vue&type=script&setup=true&lang=js"
export * from "./listSubject.vue?vue&type=script&setup=true&lang=js"

import "./listSubject.vue?vue&type=style&index=0&id=2bd2b64f&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd2b64f"]])

export default __exports__